// CustomTooltip.tsx
import { FC } from "react";
import { Box, Stack, Typography } from "@mui/material";
import { TooltipProps } from "recharts";
import { NameType, ValueType } from "recharts/types/component/DefaultTooltipContent";
import { formatNumber } from "../../../../../common/utils";
import { ThemeColors } from "../../../../../theme/themeValues";

interface ExtraProps {
	isMulti?: boolean;
	total?: number;
}

type Props = TooltipProps<ValueType, NameType> & ExtraProps;

const CustomTooltip: FC<Props> = ({ active, payload, label, isMulti, total }) => {
	const isVisible = active && payload && payload.length > 0;
	if (!isVisible) return null;

	const measure = payload?.[0]?.payload?.measure ?? "";

	return (
		<Box
			sx={{
				backgroundColor: ThemeColors.LightBackground,
				border: "1px solid black",
				borderRadius: "5px",
				boxShadow: 1,
			}}
			p={1}
		>
			<Typography variant="caption" fontWeight={700} style={{ color: ThemeColors.DarkContrastText }}>
				{label}
			</Typography>

			<Stack spacing={1} mt={1}>
				{isMulti && (
					<Stack
						direction="row"
						justifyContent="space-between"
						sx={{ borderBottom: "1px solid #ccc", mb: 0.5, pb: 0.5 }}
					>
						<Typography variant="caption" style={{ color: ThemeColors.DarkContrastText }}>
							Total
						</Typography>

						<Typography variant="caption" style={{ color: ThemeColors.DarkContrastText }}>
							{formatNumber(total ?? 0, "decimal", 2, 2)} {measure}
						</Typography>
					</Stack>
				)}

				{payload.map((entry, index) => (
					<Stack spacing={2} key={index} direction="row" justifyContent="space-between" alignItems="center">
						<Stack direction="row" alignItems="center" spacing={0.5}>
							<Box
								sx={{
									width: 10,
									height: 10,
									backgroundColor: entry.color ?? "black",
									borderRadius: 0.5,
								}}
							/>
							<Typography variant="caption" style={{ color: ThemeColors.DarkContrastText }}>
								{entry.name}
							</Typography>
						</Stack>

						<Typography variant="caption" style={{ color: ThemeColors.DarkContrastText }}>
							{formatNumber(Number(entry.value) ?? 0, "decimal", 2, 2)} {measure}
						</Typography>
					</Stack>
				))}
			</Stack>
		</Box>
	);
};

export default CustomTooltip;
